import React from 'react';
import styles from './IconContainer.module.css';

interface Props {
  icon: string;
  backgroundColor?: string;
}

function IconContainer({ icon, backgroundColor = '#EEEEEE' }: Props) {
  return (
    <div style={{ backgroundColor }} className={styles.iconContainer}>
      {icon}
    </div>
  );
}

export default IconContainer;
